<mat-dialog-content>
  <lemon-dialog-header> Kirjaa suoriteperusteisena </lemon-dialog-header>

  <div class="tosite-tiedot">
    <form novalidate style="margin: 0">
      <mat-form-field>
        <input type="text" [max]="viimeinenPaiva" [min]="ensimmainenPaiva" [matDatepicker]="picker" tahtiOhjeeseen [formField]="lomake.kirjauksenPvm" placeholder="Laskun päivämäärä" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-error>Päivämäärä puuttuu</mat-error>
      </mat-form-field>
      <mat-datepicker #picker></mat-datepicker>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (kirjaa suoriteperusteisena dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="kopioi()" actionId="Kirjaa suoriteperusteisena" [actionContext]="[lomake().value()]">Kirjaa suoriteperusteisena</app-primary-button>
</mat-dialog-actions>
